export default function Nature_origin(){
    return (
      <div className="py-5">
        <p className="text-start font-semibold pt-2 page_headers header_color">
          ORIGIN
        </p>
        <p className=" non_table_block_padding text-start">
          <span className="page_pera_font_size font-semibold">
            Chemical category
          </span>{' '}
          :{' '}
          <span className="page_pera_font_size page_pera_color">
            {/* Lipidic derivative / fatty substance */}
          </span>
        </p>
        <div className=" flex ">
          <p className="non_table_block_padding text-start font-semibold min-w-fit page_pera_font_size">
            Composition :{' '}
          </p>
          <span className="text-start page_pera_font_size page_pera_color ">
            {/* Granlipid RSC is supplied as a non-aqueous solution rich in 
                phytoglycolipids (cerebrosides), triglycerides, fatty acids, 
                hydrocarbons and phytosterols. The composition is very similar 
                to that of human epidermal lipids.  */}
          </span>
        </div>
        {/* 
             <div className="flex " >
            <p className="text-start font-semibold min-w-fit page_pera_font_size" >Botanicals used : </p>
            <div className="flex gap-2 items-center" >
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Barley
            </span>
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Sunflower
            </span>
            <span className="text-start page_pera_font_size titles_cards page_pera_color" >
                Wheat
            </span>
            </div>
            </div> */}
      </div>
    );
}